import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { useHistory } from "react-router-dom";

const Reset = () => {
  const dispatch = useDispatch();
  const closed = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const navigate = useHistory();

  return (
    <div className="_reset_bg">
      <div className="reset_area">
        <button type="button" aria-label="닫기" title="초기화 창 닫기" className="_close_btn_div" onClick={closed} >
          <i className="ri-close-line-2" />
        </button>

        <div className="fd_name">대화 내용이 초기화됩니다.</div>
        <button type="button"
          title="확인"
          className="fd_send_btn"
          onClick={() => {
            let target = '/chat'
            if(sessionStorage.getItem('mbrId')) target = target + '?id=' + btoa(sessionStorage.getItem('mbrId'));
            navigate.push(target);
            window.location.reload();
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default Reset;
